export default "__VITE_ASSET__BQN9rvKm__"